// MAIN COLORS - VUESAX THEME COLORS
let colors = {
	primary: '#15B0CE', // (Default: '#15B0CE')
	success: '#28C76F',
	danger: '#EA5455',
	warning: '#FF9F43',
	dark: '#1E1E1E',
}

import Vue from 'vue'
import Vuesax from 'vuesax'
Vue.use(Vuesax, { theme:{ colors } });

export default colors;
